module.exports = __webpack_public_path__ + "img/start.dbb74e5f.png";